'use client';

import React, { useCallback } from 'react';
import Link from 'next/link';

export type AnchorLinkProps = React.ComponentProps<typeof Link>;

export function AnchorLink({ href, onClick, children, ...props }: AnchorLinkProps) {
    const handleAnchorClick = useCallback(
        (e: React.MouseEvent<HTMLAnchorElement>) => {
            const hrefString = href.toString();

            if (hrefString.startsWith('#')) {
                const targetId = hrefString.substring(1);
                const element = document.getElementById(targetId);

                if (element) {
                    // Wenn wir bereits den Hash in der URL haben, scrollt der Browser bei erneutem Klick auf next/link nicht.
                    // Daher erzwingen wir das Scrollen.
                    if (window.location.hash === hrefString) {
                        e.preventDefault();
                        element.scrollIntoView({ behavior: 'smooth' });
                    }
                }
            }

            if (onClick) {
                onClick(e);
            }
        },
        [href, onClick],
    );

    return (
        <Link href={href} onClick={handleAnchorClick} {...props}>
            {children}
        </Link>
    );
}
